<template>
  <v-container class="mx-3 my-1" fluid>
    <v-row class="mx-7">
      <v-col
        class="d-flex justify-center text-h3 font-weight-light text-center"
      >
        {{ $t("instructions.userManual") }}
      </v-col>
    </v-row>
    <v-row class="ma-5">
      <!--TODO: ADD FAQ (later)-->
    </v-row>
    <v-row class="ma-5">
      <div class="mx-4 mb-5">
        <h4>Downloadable Guides</h4>
        <h6>For offline references</h6>
      </div>
      <!-- guides-->
      <v-col md="12" cols="12" class="d-flex flex-gap-4 flex-column">
        <!--user guide-->
        <v-card
          @click="downloadFile('userGuide')"
          outlined
          class="pa-5 download-card"
        >
          <div class="d-flex align-center justify-space-between px-4">
            <!--doc info-->
            <div class="d-flex align-center flex-gap-4 px-2">
              <div class="icon-bg">
                <v-icon style="height: 100%; width: 100%"
                  >mdi-file-document-outline</v-icon
                >
              </div>
              <div>
                <h2>{{ $t("instructions.userManual") }}</h2>
                <div>
                  <p class="ma-0 pa-0">
                    The step-by-step user guide. Download it for offline
                    reference.
                  </p>
                  <p class="ma-0 pa-0">PDF &#46; 12 pages &#46; 2.4 MB</p>
                </div>
              </div>
            </div>
            <!--doc cta-->
            <div class="cta">
              <v-btn outlined><v-icon>mdi-download</v-icon>Download</v-btn>
            </div>
          </div>
        </v-card>
        <!--kyc guide-->
        <v-card
          @click="downloadFile('kycGuide')"
          outlined
          class="pa-5 download-card"
        >
          <div class="d-flex align-center justify-space-between px-4">
            <!--doc info-->
            <div class="d-flex align-center flex-gap-4 px-2">
              <div class="icon-bg">
                <v-icon style="height: 100%; width: 100%"
                  >mdi-file-document-outline</v-icon
                >
              </div>
              <div>
                <h2>{{ $t("instructions.kyc") }}</h2>
                <div>
                  <p class="ma-0 pa-0">
                    The step-by-step know your customer (KYC). Download it for
                    offline reference.
                  </p>
                  <p class="ma-0 pa-0">PDF &#46; 5 pages &#46; 2.4 MB</p>
                </div>
              </div>
            </div>
            <!--doc cta-->
            <div class="cta">
              <v-btn outlined><v-icon>mdi-download</v-icon>Download</v-btn>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4"></v-col>
      <v-col cols="4" md="4">
        <v-card outlined class="d-flex align-center mt-5 flex-column">
          <v-card-title class="mx-auto">
            {{ $t("requestHelp.cantFindIt") }}
          </v-card-title>
          <v-row>
            <v-col cols="12" class="pa-7">
                <div>
                  <v-btn
                    filled
                    tile
                    large
                    color="primary"
                    href="mailto:support@clearfxai.com"
                    target="_blank"
                  >
                    <span class="text-capitalize">
                      {{ $t("requestHelp.contactUs") }}
                    </span>
                  </v-btn>
                </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="4"></v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      pdf: "/pdf/tos_blank.pdf",
    };
  },
  methods: {
    async downloadFile(id) {
      try {
        const filename = `${id}.pdf`;

        const link = document.createElement("a");
        link.href = this.pdf;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>
.icon-bg {
  background-color: #0073ff65;
  height: 45px;
  width: 45px;
  align-self: center;
}
.download-card:hover {
  border-color: #0073ff;
  cursor: pointer;
  background: #262626;
  transition: all 0.4s ease;
}
.download-card:hover .cta {
  display: flex;

  transition: all 0.4s ease;
}
.cta {
  display: none;
}
</style>
